import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';


export function GetPermsList(data) {
    return request({
        url:Api.perm.list,
        method:configs.http.request.methodGet,
        data
    })
}


export function GetPermByRoleId(data){
    return request({
        url:Api.role.perm+data.id,
        method:configs.http.request.methodGet,
        data
    })
}


export function BindPermsByRoleId(data){
    return request({
        url:Api.role.perm_bind,
        method:configs.http.request.methodPost,
        data
    })
}